<script>
import resources from './resources'

export default {
  name: 'professional-documents-index',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Meus Documentos", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          .nav-tabs-wrapper
            ul.nav.nav-tabs.nav-340
              li
                router-link(:to="{ name: 'professional.company.documents.create'  }")
                  | Listagem

              li.active
                a(href='#') Documentos

          .col-xs-12.white-bg.wrapper(v-if="loading")
            .row.border-bottom-light
              spinner-professional(:show="true")
          .col-xs-12.white-bg.wrapper(v-if="!loading")
            card-add(label='Novo<br>Documento',
            route='professional.company.documents.create', icon='')

            .list-item.white-bg.list-item(v-for="document in documents")
              .row.border-bottom
                h4.col-xs-7 {{ document.slug }}
                .col-xs-5
                  .exclude-list(@click.prevent="doDelete(document)")
                    span.icon 
              .list-info
                strong {{ document.label }}
                br
                | {{ document.document_status }}
      .pagination
        pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/company/documents/index/index.vue